"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSkipCurrentBlock = void 0;
const store2_1 = __importDefault(require("store2"));
const taskStore_1 = require("../../../taskStore");
const getStimulus_1 = require("./getStimulus");
function skipBlock() {
    const skipBlockTrialType = store2_1.default.page.get('skipCurrentBlock');
    (0, taskStore_1.taskStore)('trialsSkipped', 0);
    while ((0, taskStore_1.taskStore)().nextStimulus.trialType === skipBlockTrialType) {
        // do not call getStimulus if there are no remaining stimuli
        if ((0, taskStore_1.taskStore)().corpora.stimulus.length === 0) {
            break;
        }
        (0, getStimulus_1.getStimulus)('stimulus');
        const trialsSkipped = (0, taskStore_1.taskStore)().trialsSkipped;
        (0, taskStore_1.taskStore)('trialsSkipped', trialsSkipped + 1);
    }
}
const setSkipCurrentBlock = (skipTrialType) => {
    if (!!store2_1.default.page.get('failedPrimaryTrials') && (0, taskStore_1.taskStore)().numIncorrect >= 1 && !(0, taskStore_1.taskStore)().heavyInstructions) {
        (0, taskStore_1.taskStore)('numIncorrect', 0);
        store2_1.default.page.set('skipCurrentBlock', skipTrialType);
        skipBlock();
    }
    else if ((0, taskStore_1.taskStore)().numIncorrect >= (0, taskStore_1.taskStore)().maxIncorrect) {
        (0, taskStore_1.taskStore)('numIncorrect', 0);
        store2_1.default.page.set('skipCurrentBlock', skipTrialType);
        store2_1.default.page.set('failedPrimaryTrials', true);
        skipBlock();
    }
};
exports.setSkipCurrentBlock = setSkipCurrentBlock;
